import request from 'services/axios';

export const getWholesalerSaleTypes = async () => {
  const {data}: {data: IGetSalesType[]} = await request.get(
    `/api/v2/market/sale-type?app=market`,
  );
  return data;
};
